import React from "react";
import "./Faq_content.css";
import Faq_Accordion from "./Faq_Accordion/Faq_Accordion";
import Query_Form from "./Query_Form/Query_Form";

function Faq_content() {
  return (
    <>
      <section className="Faq_content">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <Faq_Accordion />
            </div>

            <div className="col-md-6">
              <Query_Form />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq_content;
